import React from 'react';
import { Link } from 'react-router-dom';

import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Form } from '@/components/ui/form';
import { Alert } from '../../../../shared/components/Alert';
import { InputField, SubmitButton } from '../../../../shared/components/Form';
import { FORGOT_PASSWORD, REQUEST_UNLOCK, SIGNUP } from '../../../shared/constants';
import Header from '../components/Header';
import { ERROR_TITLES } from '../constants';
import { useLoginForm } from '../hooks';

const alertIcon = <FontAwesomeIcon icon={faCircleExclamation} />;

const ForgotPasswordLink = () => (
  <Link
    to={FORGOT_PASSWORD}
    className="text-sidebar-foreground underline-offset-4 hover:underline"
  >
    Forgot your password?
  </Link>
);

const LOCKED_DESCRIPTION = (
  <>
    Check your email for an unlock link. Didn&apos;t receive it?{' '}
    <Link className="underline underline-offset-4" to={REQUEST_UNLOCK}>
      Request another
    </Link>
    .
  </>
);

const Login = () => {
  const {
    error,
    form,
    handleSubmit: onSubmit,
    isSubmitting,
    isUserLocked,
  } = useLoginForm();

  return (
    <div className="flex items-center justify-center bg-muted min-h-svh">
      <div className="flex flex-col gap-6 w-full max-w-xs">
        <Header title="Login" />

        <Form {...form}>
          <form className="flex flex-col gap-6" onSubmit={form.handleSubmit(onSubmit)}>
            <InputField control={form.control} label="Email" name="email" type="email" />

            <InputField
              control={form.control}
              label="Password"
              labelEnd={<ForgotPasswordLink />}
              name="password"
              type="password"
            />

            <div className="flex flex-col gap-2">
              <SubmitButton isLoading={isSubmitting}>Login</SubmitButton>

              <p className="text-sidebar-foreground text-center">
                Don&apos;t have an account?{' '}
                <Link to={SIGNUP} className="underline-offset-4 hover:underline">
                  Sign up
                </Link>
              </p>
            </div>

            {isUserLocked && (
              <Alert
                description={LOCKED_DESCRIPTION}
                icon={alertIcon}
                title={error.message}
                variant="destructive"
              />
            )}

            {error && !isUserLocked && (
              <Alert
                description={error.message}
                icon={alertIcon}
                title={ERROR_TITLES.session.create}
                variant="destructive"
              />
            )}
          </form>
        </Form>
      </div>
    </div>
  );
};

export default Login;
